import { z } from 'zod';

export const MyWhatsAppPathParamsSchema = z.object({ workspaceId: z.uuid() });

export const MyWhatsAppConnectionResponseSchema = z.object({
  available: z.boolean(),
  immoosNumber: z.string().nullable(),
  connection: z.object({ phone: z.string(), connectedAt: z.iso.datetime() }).nullable(),
});
export type MyWhatsAppConnectionResponse = z.infer<typeof MyWhatsAppConnectionResponseSchema>;

export const IssueWhatsAppLinkCodeResponseSchema = z.object({
  code: z.string(),
  expiresAt: z.iso.datetime(),
  immoosNumber: z.string(),
});
export type IssueWhatsAppLinkCodeResponse = z.infer<typeof IssueWhatsAppLinkCodeResponseSchema>;
